import { Link } from "react-router-dom";
import { NAV_LINKS, CALENDLY_URL } from "@/config";
import { useAnchorNav } from "@/components/Nav";

export default function Footer() {
  const go = useAnchorNav();
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-parch">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <img
              src="/assets/kp-logo.png"
              alt="KP Strategy — Product & Systems"
              className="h-11 w-auto"
            />
            <p className="mt-5 text-sm leading-relaxed text-body">
              A product and systems consultancy helping founders, service
              businesses and nonprofits build better products, programs and
              ways of working.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-faint">
              Kristel Procida — Founder.
            </p>
          </div>
          <nav className="flex flex-col gap-3" aria-label="Footer">
            {NAV_LINKS.map((l) =>
              l.to ? (
                <Link
                  key={l.label}
                  data-testid={`footer-${l.testid}`}
                  to={l.to}
                  className="text-sm text-body transition-colors hover:text-amber"
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.label}
                  data-testid={`footer-${l.testid}`}
                  href={l.hash}
                  onClick={(e) => {
                    e.preventDefault();
                    go(l.hash);
                  }}
                  className="text-sm text-body transition-colors hover:text-amber"
                >
                  {l.label}
                </a>
              )
            )}
            <Link
              data-testid="footer-link-contact"
              to="/contact"
              className="text-sm text-body transition-colors hover:text-amber"
            >
              Contact
            </Link>
            <a
              data-testid="footer-link-calendly"
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-semibold text-amber transition-colors hover:text-amber-dark"
            >
              Book an Intro Call
            </a>
          </nav>
        </div>
        <div className="mt-12 flex flex-col gap-2 border-t border-ink/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-xs uppercase tracking-wider text-faint">
            © 2026 KP Strategy. All rights reserved.
          </p>
          <p className="font-mono text-xs uppercase tracking-wider text-faint">
            Design like a product · Run like a system · Scale with AI
          </p>
        </div>
      </div>
    </footer>
  );
}
